import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const data = [
  {
    farm_name: "Obasanjo Farms Nigeria",
    program: "Agbeloba Aquaculture Hub",
    description:
      "The design, construction and the final setup of the Agbeloba Aquaculture Hub.",
  },
  {
    farm_name: "AIF",
    program: "African Inland Fisheries Ltd",
    description:
      "We receive requests form African Inland Fisheries Ltd all year round for the construction and installation of fish equipment and infrastructures.",
  },
  {
    farm_name: "OORBDA",
    program: "Ogun-Oshun River Basin Development Authority",
    description:
      "AHAN is the go-to center for the design, fabrication and installation of all Ogun-Oshun River Basin Development's Aquaculture equipment on the Oyan Dam.",
  },
  {
    farm_name: "AFOS",
    program: "AFOS Foundation",
    description:
      "From Aquaponics Setup and Installation to the fabrication of Modern Fish Dryers, AHAN is the one-stop centre for all AFOS Fish Farmers.",
  },
];

const Technical = () => {
  return (
    <Box
      margin={{ xs: "20% 0%", sm: "10% 0%" }}
      sx={{
        position: "relative",
        "&::after": {
          position: "absolute",
          content: '""',
          width: "40%",
          zIndex: 1,
          top: 0,
          right: 0,
          height: "35%",
          backgroundSize: "18px 18px",
          backgroundImage: `radial-gradient(${"#fff"} 20%, transparent 30%)`,
          opacity: 0.1,
        },
      }}
    >
      <Typography
        variant={"h3"}
        fontWeight={900}
        textAlign={"left"}
        color={"#fff"}
        paddingBottom={"1%"}
      >
        Our Technical Projects
      </Typography>
      <Grid container spacing={1}>
        {data.map((list, index) => {
          const { farm_name, program, description } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={2.8}
                marginTop={{ xs: "25%", sm: "3%" }}
                key={index}
                padding={{ xs: "0%", sm: "0% 1.5%" }}
                marginRight={{ xs: "0%", sm: "1%" }}
                // borderRadius={"5px"}
                borderRight={{
                  xs: "0px solid #F4F9FF",
                  sm: "1px solid #F4F9FF",
                }}
              >
                <Typography
                  gutterBottom
                  variant="body1"
                  color={"#fff"}
                  component="div"
                  fontWeight={700}
                  paddingBottom={"1%"}
                >
                  {farm_name}
                </Typography>
                <Typography
                  gutterBottom
                  variant="h4"
                  color={"#fff"}
                  component="div"
                  fontWeight={700}
                  paddingBottom={"1%"}
                >
                  {program}
                </Typography>
                <Typography variant="body1" color="#fff">
                  {description}
                </Typography>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Technical;
